import { defineComponent as _defineComponent } from 'vue'
import { ref as _ref } from 'vue';

import { onMounted, ref, watch } from 'vue';
import type { QueryType } from '@/utils/query';

interface CatalogSearchProps {
  shouldSearchInFields: boolean,
  textSearch: string,
  sort: string[]
}

type CatalogSearchEmits = {
  (event: 'onFilterChange', filter: { [key: string]: QueryType }): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Catalog-Search',
  props: {
  shouldSearchInFields: { type: Boolean, default: false },
  textSearch: { default: '' },
  sort: null
},
  emits: ["onFilterChange"],
  setup(__props, { emit }) {

const props = __props;




const shouldSearchInFields = ref(props.shouldSearchInFields);
const textSearch = ref<string>(props.textSearch);
const searchInputRef = ref<HTMLInputElement | null>(null);

let previousTextSearch = _ref<string>(props.textSearch);

const handleSearchKey = () => {
  if (previousTextSearch.value !== textSearch.value) {
    emit('onFilterChange', { textSearch: textSearch.value || '' });
    previousTextSearch.value = textSearch.value;
  }
};

const handleSearchClear = () => {
  textSearch.value = '';
  handleSearchKey();
};

const handleSort = (value: { [key: string]: QueryType}) => {
  emit('onFilterChange', { ...value });
};

onMounted(() => {
  searchInputRef.value!.focus();
});

watch(() => shouldSearchInFields.value, () => {
  emit('onFilterChange', { searchInFieldsAndDescriptions: String(shouldSearchInFields.value) });
});

return { __sfc: true,props, emit, shouldSearchInFields, textSearch, searchInputRef, previousTextSearch, handleSearchKey, handleSearchClear, handleSort, _ref, onMounted, ref, watch }
}

})